import { render } from "./MethodologyPage.vue?vue&type=template&id=1c70c832&scoped=true"
import script from "./MethodologyPage.vue?vue&type=script&lang=js"
export * from "./MethodologyPage.vue?vue&type=script&lang=js"

import "./MethodologyPage.vue?vue&type=style&index=0&id=1c70c832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c70c832"]])

export default __exports__